<dgx-cookie-banner
  *dgxFeatureToggle="'degreed-cookie-banner'; hidden: false"
  [userHasAcceptedPrivacyPolicy]="userHasAcceptedPrivacyPolicy"
></dgx-cookie-banner>

<div class="login full-height">
  <div class="grid grid--full-width full-height">
    <div class="no-mobile grid__col-6 account__photo"></div>
    <div class="grid__col-auto center-text grid--align-self-center">
      <div class="m-guts-p-t-1 m-guts-p-b-16 guts-p-t-2 guts-p-b-8">
        <a href="/" class="ib rel guts-m-b-1" data-dgat="LogIn-899">
          <img
            [src]="logoUrl"
            static="true"
            alt="Degreed"
            width="37"
            height="24"
            role="img"
          />
        </a>

        <dgx-login-form
          *ngIf="isLogin"
          [captchaKey]="captchaKey"
          [errors]="errors"
          [loginScope]="loginScope"
          [mobileSkip]="mobileSkip"
          [passedData]="passedData"
          (preserveReturnUrl)="preserveReturnUrl()"
          [returnUrl]="returnUrl"
          (setUtm)="setUtm()"
          [specialInstructions]="specialInstructions"
          [ssoId]="ssoId"
          [ssoName]="ssoName"
          [username]="username"
          (goToState)="goToState($event)"
        ></dgx-login-form>

        <dgx-signup-form
          *ngIf="isSignup"
          [captchaKey]="captchaKey"
          [errors]="errors"
          [loginScope]="loginScope"
          [passedData]="passedData"
          [returnUrl]="returnUrl"
          (preserveReturnUrl)="preserveReturnUrl()"
          (setUtm)="setUtm()"
          [specialInstructions]="specialInstructions"
        >
        </dgx-signup-form>

        <dgx-forgot-password-form
          *ngIf="isForgotPassword"
          [errors]="errors"
          [passedData]="passedData"
          [specialInstructions]="specialInstructions"
          (preserveReturnUrl)="preserveReturnUrl()"
          (setUtm)="setUtm()"
          (goToState)="goToState($event)"
        >
        </dgx-forgot-password-form>
      </div>
    </div>
  </div>
</div>
